// extracted by mini-css-extract-plugin
module.exports = {"row":"UO1JW","block":"_90tgQ","portrait":"g4igE","landscape":"qORSh"};